import { JAB } from '../cards/attack/jab';
import { WORLDBREAKER } from '../cards/attack/worldbreaker';
import { AEGIS } from '../cards/defense/aegis';
import { COLD_SNAP } from '../cards/trap/cold-snap';
import { DOOMSDAY_CLOCK } from '../cards/trap/doomsday-clock';
import type { EnemyTemplate } from './template';

/** HEX-83 roster (docs/enemies.md). Legendary tier: 4×4, 5 dice, trap-aware AI.
 * The wall-and-hammer final test — the AI optimally alternates a 20-block-
 * equivalent defence with Worldbreaker swings, runs the Clock as a finisher, and
 * freezes your key card on an unlucky roll. The complete legendary: damage,
 * defence, self-pressure and denial in one loadout. */
export const AVATAR_OF_RUIN: EnemyTemplate = {
  id: 'avatar-of-ruin',
  name: 'Avatar of Ruin',
  glyph: '☢', // ruin sigil
  tier: 'legendary',
  hp: 57,
  loadout: [
    { card: WORLDBREAKER, origin: { row: 0, col: 0 }, rotated: false },
    { card: JAB, origin: { row: 0, col: 3 }, rotated: false },
    { card: COLD_SNAP, origin: { row: 1, col: 3 }, rotated: false },
    { card: AEGIS, origin: { row: 2, col: 0 }, rotated: false },
    { card: DOOMSDAY_CLOCK, origin: { row: 2, col: 2 }, rotated: false },
  ],
  drops: { gold: 50 },
};
